import { Route } from '@/types'

export const kidsroute: Route = {
  id: 'kidsroute',
  label: 'Kids',
  duration: 'De fietstocht zal ongeveer 2-2,5 uur duren.',
  center: {
    lat: 51.222334052000555,
    lon: 4.397256409857123
  },
  steps: [
    {
      label: 'Het Steen',
      component: 'Steen',
      coordinates: {
        lat: 51.222334052000555,
        lon: 4.397256409857123
      },
      instruction:
        'Zet je op een mooi plekje met zicht op Het Steen en het water en klik vervolgens op het vraagteken icoontje. Je zal dit icoontje zien terugkomen tijdens de tocht wanneer je een vraag of opdracht moet oplossen. Wanneer de stopplek info geeft, zonder een opdracht, krijg je volgend icoontje te zien: <span class="c-icon ri-information-line"></span>. Succes!',
      nextSteps:
        'Neem je fiets en rijd de parking van Het Steen buiten. Je neemt het fietspad naar links en fietst 1,5 km verder. Aan je rechterkant zal je het MAS zien. Fiets nog een klein stukje verder en houdt pauze aan de hoge kranen aan het water op je linkerkant.',
      type: 'game'
    },
    {
      label: 'Oude kranen waagnatie & Red Star Line',
      component: 'OudeHavenkranen',
      coordinates: {
        lat: 51.230931811760215,
        lon: 4.402716880285529
      },
      poiCoordinates: {
        lat: 51.23139714413467,
        lon: 4.401687662708063
      },
      instruction: 'Wandel met je fiets even tot bij de oude Havenkranen',
      nextSteps:
        'We fietsen verder en steken de Kattendijkbrug over. Achter de brug zie je aan je linkerkant een plein met trappen. Houd daar pauze.',
      type: 'info'
    },
    {
      label: 'Scheldebocht, Stormkop & het droogdokkenpark',
      component: 'Droogdokkenpark',
      coordinates: {
        lat: 51.236219174621056,
        lon: 4.403155745047149
      },
      poiCoordinates: {
        lat: 51.23635688198607,
        lon: 4.402662218601506
      },
      instruction: 'Wandel met je fietsen tot aan de trappen en zet je even',
      nextSteps:
        'We springen terug op de fiets naar de volgende locatie, net aan de overkant van de Royerssluis. Tip: één van de twee zijden is altijd gesloten. Indien de brug aan de linkse kant open staat, zal je even moeten omfietsen langs rechts. We houden pauze net achter de brug aan de linkerkant, waar je een frituur ziet staan.',
      type: 'game'
    },
    {
      label: 'Royerssluis',
      component: 'Royerssluis',
      coordinates: {
        lat: 51.241066117995686,
        lon: 4.401245104937419
      },
      poiCoordinates: {
        lat: 51.24099223385382,
        lon: 4.401229011683756
      },
      instruction:
        'Stap even af je fiets en houdt een pauze ter hoogte van Frituur Royerssluis',
      nextSteps:
        'Wandel met je fiets even het kleine weggetje op naar boven tot je aan een gebouw (Hoge Zeevaartschool) komt.',
      type: 'game'
    },
    {
      label: 'Hoge zeevaartschool',
      component: 'HogeZeevaartschool',
      coordinates: {
        lat: 51.24014697486686,
        lon: 4.398671227536888
      },
      instruction:
        'Zet je even op het gras aan de kant van het fietspad. Wandel nadien met fiets aan de hand even verder tot de volgende stop.',
      nextSteps:
        'Fiets 500 meter verder tot je een mooi uitzicht over het water van Het Noordkasteel hebt en zet je fietsen even naast de fietsdijk op het gras.',
      type: 'info'
    },
    {
      label: 'Het Noordkasteel',
      component: 'Noordkasteel',
      coordinates: {
        lat: 51.240093239875,
        lon: 4.392400222843129
      },
      instruction: 'Zet je even op het gras aan de kant van het fietspad',
      nextSteps:
        'Tijd om even terug de fiets op te springen voor een langer stukje! We fietsen 2,8 km verder richting de Haven. Op je rechterkant zal je het industrieterrein van Total Polymers zien. Volg de fietsberm aan de kant van het water tot je aan een boompje met een cortenstaal kunstwerk ernaast komt.',
      type: 'game'
    },
    {
      label: 't Boomke',
      component: 'Boomke',
      coordinates: {
        lat: 51.2438501,
        lon: 4.3550551
      },
      poiCoordinates: {
        lat: 51.245101886076924,
        lon: 4.352359766993577
      },
      nextSteps:
        'Vervolgens moeten we de straat oversteken richting de Kastelweg. Eén kilometer verder sluit het fietspad aan op de dijk aan de Scheldelaan. Wel zal je dan even moeten terugfietsen tot je terug aan dit punt komt. Onderweg kom je rondvormige benzine-opslagtanks tegen van ongeveer 55.000 kubieke meter, oftewel 25 keer de inhoud van een olympisch zwembad. Durvers kunnen natuurlijk altijd een veilig plekje zoeken om met de fiets aan de hand van de berm te stappen om vervolgens de straat over te steken naar de Kastelweg. Je fietst voorbij het gebouw van Diamur, producent van beton en cement, en houdt halt aan een brug over de straat tussen Katoen Natie en Total Polymers.',
      type: 'info'
    },
    {
      label: 'Kastelweg (Total Polymers - Katoennatie + chinatrein))',
      component: 'Kastelweg',
      coordinates: {
        lat: 51.24383061879029,
        lon: 4.370053897889506
      },
      instruction:
        'Zet je fiets even - zo voorzichtig mogelijk - aan de kant van het fietspad tegen het hek',
      type: 'game'
    },
    {
      label: 'Oosterweel - Kerkje',
      component: 'Oosterweel',
      coordinates: {
        lat: 51.243192370576494,
        lon: 4.379061376599354
      },
      type: 'info',
      nextSteps:
        'Steek de straat terug over en zet je even op het gras vlakbij de windturbine die boven je uittorent.'
    },
    {
      label: 'Windturbine achter Noordkasteelbrug',
      component: 'Windturbine',
      coordinates: {
        lat: 51.250132887409215,
        lon: 4.388150353697313
      },
      type: 'game',
      nextSteps:
        'Nu fietsen we weer een eindje! Zo’n 3 kilometer. Je fietst zo dadelijk opnieuw het water over. Fiets verder tot je aan een kruispunt met verkeerslichten komt. Draai daar rechts in. Blijf verder fietsen tot je aan de bushalte bent.'
    },
    {
      label:
        'Molenbergnatie (aan de overkant vd straat) + Euroports (deze kant vd straat)',
      component: 'Molenbergnatie',
      coordinates: {
        lat: 51.26085225543602,
        lon: 4.404406290839799
      },
      instruction: 'Zet je fiets even aan het gras achter de bushalte',
      nextSteps:
        'We stappen terug op de fiets en fietsen zo’n 10 minuten verder tot Gaarkeuken 110. Gezien vooral dokwerkers op deze plek terug energie komen opdoen is de Gaarkeuken wel gesloten in het weekend. Zo dadelijk kom je voorbij een ander magazijn van Euroports. Aan de overkant zal je zien dat containers opgestapeld staan. Interessant weetje: Als er meer dan drie containers bovenop elkaar staan, wil dat zeggen dat ze zeker leeg zijn. Blijf op de Vosseschijnstraat fietsen tot je voorbij de hangars van katoennatie komt. Aan je rechterkant zal je een huis met een kleine parking zien, waar we de volgende stop houden.',
      type: 'game'
    },
    {
      label: 'Gaarkeuken 110',
      component: 'Gaarkeuken',
      coordinates: {
        lat: 51.24843201635423,
        lon: 4.4158792624408685
      },
      instruction: 'Zet je even op het gras aan de parking van Gaarkeuken 110',
      nextSteps:
        'We fietsen door tot Het Havenhuis. Blijf de weg volgen aan de rechterkant tot je op het kruispunt komt. Steek het kruispunt over richting de brug. Vanaf daar zie je het Havenhuis al fonkelen. Eens aangekomen aan het Havenhuis, zet je je fiets onder de punt van het Havenhuis, aan de kant van het water.',
      type: 'game'
    },
    {
      label: 'Hand van Antigoon / Havenhuis',
      component: 'Havenhuis',
      coordinates: {
        lat: 51.240841795505105,
        lon: 4.408064969534603
      },
      poiCoordinates: {
        lat: 51.24040552453256,
        lon: 4.407293908109775
      },
      instruction:
        'Wandel onder de punt van het Havenhuis door tot aan de oever',
      nextSteps:
        'Neem je fiets en ga in de richting van de Mexicostraat (je ziet een gebouw met geel logo van DHL). Fiets verder tot je aan je linkse kant het schip ‘Sint-Jozef’ ziet liggen.',
      type: 'game'
    },
    {
      label: 'Kerkschip',
      component: 'Kerkschip',
      coordinates: {
        lat: 51.23743435069007,
        lon: 4.408985876889204
      },
      instruction: 'Zet je even aan de kant van het fietspad',
      nextSteps:
        'Op naar onze laatste stop! Steek te voet de Mexicobrug over en fiets verder tot aan het MAS. Wil je onderweg nog graag een stop inlassen? Aan je linkerkant passeer je zo dadelijk de Seef brouwerij. Aan de hangars aan de overkant van de straat (kant van het water) kan je ook terecht voor een lekkere drankje en hapjes! Ga aan het kruispunt met de Londenbrug rechts over de brug. Sla nadien de 2de straat links in om tot bij het MAS aan te komen.',
      type: 'info'
    },
    {
      label: 'MAS Havenpaviljoen',
      component: 'MAS',
      coordinates: {
        lat: 51.22860066479189,
        lon: 4.405530530455637
      },
      type: 'info'
    }
  ],
  geometry: {
    coordinates: [
      [4.397657317791013, 51.22225999999998],
      [4.398208317791012, 51.223133999999966],
      [4.398250317791013, 51.22324399999997],
      [4.399280317791011, 51.224858999999995],
      [4.399303317791014, 51.224893999999985],
      [4.400161317791013, 51.22625999999996],
      [4.400231317791013, 51.22636199999999],
      [4.400309317791011, 51.22646000000002],
      [4.400747317791013, 51.226962000000015],
      [4.400800317791012, 51.22701799999999],
      [4.401170317791012, 51.22738999999995],
      [4.401254317791013, 51.22744900000001],
      [4.401483317791013, 51.22767399999998],
      [4.401572317791014, 51.22776799999995],
      [4.401613317791012, 51.227817000000016],
      [4.401667317791013, 51.22788499999998],
      [4.401713317791014, 51.22795700000001],
      [4.401749317791013, 51.228024999999974],
      [4.401786317791013, 51.22809900000001],
      [4.401812317791013, 51.228165999999995],
      [4.401835317791012, 51.228247999999965],
      [4.401846317791013, 51.22832999999998],
      [4.401853317791012, 51.22841699999997],
      [4.401819317791013, 51.22941399999997],
      [4.401820317791012, 51.22951199999997],
      [4.401824317791013, 51.22954699999998],
      [4.401834317791013, 51.229600999999995],
      [4.401852317791012, 51.22965499999998],
      [4.401876317791013, 51.22970599999998],
      [4.401968317791013, 51.229880999999985],
      [4.4021163177910125, 51.230162999999976],
      [4.402305317791012, 51.23051699999998],
      [4.402539317791013, 51.230968000000004],
      [4.402556317791012, 51.23099999999998],
      [4.402607317791013, 51.23109799999998],
      [4.402672317791013, 51.231225],
      [4.402731317791013, 51.23137599999999],
      [4.402785317791014, 51.231568999999936],
      [4.402817317791012, 51.231727999999954],
      [4.402835317791013, 51.23181499999997],
      [4.402848317791013, 51.232451999999995],
      [4.402857317791013, 51.23302099999998],
      [4.402868317791013, 51.23345799999998],
      [4.402872317791013, 51.23348699999997],
      [4.402879317791013, 51.233515],
      [4.403202317791012, 51.23430300000001],
      [4.4032473177910125, 51.234421999999945],
      [4.403255317791012, 51.235014999999976],
      [4.403252317791012, 51.235288999999995],
      [4.403248317791013, 51.235316999999974],
      [4.403232317791012, 51.23542],
      [4.403225317791013, 51.23547399999998],
      [4.403168317791012, 51.235628000000005],
      [4.403098317791012, 51.23576599999999],
      [4.403051317791013, 51.23587499999999],
      [4.403034317791014, 51.23601300000001],
      [4.403058317791013, 51.23615000000001],
      [4.403104317791012, 51.23623],
      [4.403137317791011, 51.236287999999995],
      [4.403281317791013, 51.23645300000001],
      [4.403324317791013, 51.236591],
      [4.403331317791012, 51.236668],
      [4.403315317791011, 51.236732000000025],
      [4.403264317791012, 51.236939],
      [4.403248317791013, 51.23700500000001],
      [4.403211317791013, 51.23706600000002],
      [4.403079317791013, 51.23714000000001],
      [4.402945317791013, 51.23719200000001],
      [4.402430317791013, 51.23728299999996],
      [4.4022683177910125, 51.237330999999976],
      [4.4021543177910125, 51.23739299999996],
      [4.402080317791012, 51.23746800000001],
      [4.402041317791013, 51.237587999999995],
      [4.4020463177910125, 51.23762400000001],
      [4.4020643177910115, 51.237744999999954],
      [4.402088317791013, 51.23791400000002],
      [4.402120317791012, 51.23828899999997],
      [4.402183317791012, 51.23869100000001],
      [4.402312317791012, 51.239732000000004],
      [4.402289317791013, 51.23983700000001],
      [4.402251317791013, 51.23997999999997],
      [4.402190317791013, 51.24009899999998],
      [4.402103317791013, 51.240238999999974],
      [4.402083317791012, 51.240273],
      [4.402012317791012, 51.24042599999997],
      [4.401919317791013, 51.24051599999997],
      [4.401673317791013, 51.24074899999998],
      [4.4014033177910115, 51.24098999999996],
      [4.401372317791013, 51.24101199999998],
      [4.4013093177910125, 51.24104000000001],
      [4.401244317791012, 51.24106799999997],
      [4.401242317791013, 51.241068999999996],
      [4.400897317791013, 51.24116],
      [4.400863317791013, 51.24111599999998],
      [4.3998413177910125, 51.24072099999999],
      [4.399769317791013, 51.240623000000014],
      [4.398663317791012, 51.24015200000001],
      [4.398191317791013, 51.239951000000005],
      [4.397647317791012, 51.23973699999997],
      [4.397089317791012, 51.23961299999999],
      [4.396963317791012, 51.23959399999997],
      [4.396896317791013, 51.239584],
      [4.396698317791014, 51.23956799999999],
      [4.396458317791012, 51.239561999999964],
      [4.396150317791012, 51.23956600000001],
      [4.3955723177910135, 51.23964699999997],
      [4.392708317791013, 51.24006099999998],
      [4.392399317791012, 51.24009899999998],
      [4.389704317791012, 51.240426999999976],
      [4.386787317791012, 51.240778999999996],
      [4.384837317791011, 51.241021999999965],
      [4.3844893177910125, 51.24105699999995],
      [4.384345317791014, 51.241123999999985],
      [4.384111317791012, 51.24124699999999],
      [4.383857317791012, 51.241374999999984],
      [4.383156317791013, 51.24159400000001],
      [4.382619559764889, 51.24161824513538],
      [4.377880096435546, 51.24149398686326],
      [4.376860857009888, 51.24143689511218],
      [4.3758416175842285, 51.241420103407194],
      [4.374945759773254, 51.241426820089956],
      [4.373583197593689, 51.241510778541276],
      [4.370734691619873, 51.24165854504345],
      [4.368234872817993, 51.241789519500806],
      [4.366475343704224, 51.24189362713678],
      [4.364705085754394, 51.241987659637715],
      [4.362854361534119, 51.24209176682524],
      [4.361175298690796, 51.24218579892112],
      [4.3604350090026855, 51.24222945661458],
      [4.359099268913269, 51.24239401216363],
      [4.357591867446899, 51.24267610602098],
      [4.356046915054321, 51.24294140699865],
      [4.355134963989258, 51.24318319896192],
      [4.354322254657774, 51.2434518552081],
      [4.353463947773007, 51.243750733438134],
      [4.352369606494932, 51.24415371224662],
      [4.350132644176511, 51.244963017354756],
      [4.349424540996578, 51.24530218248083],
      [4.348448216915158, 51.245785740315746],
      [4.347536265850094, 51.246272651054106],
      [4.3451598286629, 51.24759232113546],
      [4.342635869979886, 51.24896232024072],
      [4.341377913951901, 51.24962715803858],
      [4.340122640132932, 51.25025169388092],
      [4.340565204620388, 51.250520308838816],
      [4.3414476513862885, 51.25004015849714],
      [4.3420082330704, 51.24971613812563],
      [4.342598319053677, 51.24940218874859],
      [4.346195161342648, 51.24759903691687],
      [4.348330199718503, 51.24638682248116],
      [4.350197017192868, 51.24539284996214],
      [4.351484477520017, 51.24497980776638],
      [4.352321326732662, 51.24465071458131],
      [4.3531581759453095, 51.24435520032689],
      [4.3537187576293945, 51.24407647491519],
      [4.359721541404724, 51.244012670065274],
      [4.369098544120789, 51.24392871618054],
      [4.369989037513733, 51.24392871618054],
      [4.370831251144408, 51.24391528354477],
      [4.372027516365051, 51.24389849274455],
      [4.374688267707825, 51.243874985613914],
      [4.383137226104736, 51.24376752429231],
      [4.383561015129089, 51.24379103147787],
      [4.383995532989502, 51.24380446414992],
      [4.385236054658916, 51.24391360446502],
      [4.385464042425183, 51.2439144440049],
      [4.385730922222165, 51.24390604860535],
      [4.385946840047863, 51.2438825414786],
      [4.386082291603116, 51.243859873880695],
      [4.386142317791012, 51.24396299999999],
      [4.386180317791012, 51.244099999999996],
      [4.386200317791013, 51.244172],
      [4.386216317791012, 51.24422999999997],
      [4.386494317791012, 51.24530499999998],
      [4.386620317791014, 51.245296999999944],
      [4.386793317791014, 51.245948],
      [4.386838317791013, 51.24611799999999],
      [4.386870317791012, 51.246171999999994],
      [4.386899317791013, 51.246273999999964],
      [4.387319317791013, 51.24785399999998],
      [4.387347317791012, 51.247961],
      [4.387353317791012, 51.248025999999975],
      [4.387402317791013, 51.24811499999999],
      [4.3874633177910125, 51.24819099999999],
      [4.3876793177910125, 51.248399999999975],
      [4.387686317791012, 51.248414000000004],
      [4.387617317791013, 51.24872199999998],
      [4.387591317791013, 51.248732999999994],
      [4.3875523177910125, 51.24874899999993],
      [4.387505317791013, 51.24876900000001],
      [4.3874753177910115, 51.24878100000001],
      [4.3874823177910125, 51.248854000000016],
      [4.387597317791013, 51.249184],
      [4.387813317791013, 51.24953799999997],
      [4.388195317791012, 51.250120999999986],
      [4.388381317791013, 51.25040499999999],
      [4.388470317791013, 51.25056499999996],
      [4.388513317791013, 51.250686999999985],
      [4.388538317791013, 51.250781000000025],
      [4.388551317791013, 51.25085799999997],
      [4.388571317791013, 51.250960999999975],
      [4.388575317791013, 51.25098300000001],
      [4.388583317791013, 51.25102199999996],
      [4.388582317791013, 51.251052999999985],
      [4.388585317791012, 51.251215999999964],
      [4.388597317791013, 51.251653999999945],
      [4.388617317791012, 51.25232099999999],
      [4.388627317791013, 51.25282],
      [4.388662317791013, 51.25420999999997],
      [4.388672317791014, 51.25456299999997],
      [4.388681317791012, 51.254999999999995],
      [4.388686317791013, 51.25519999999997],
      [4.388695317791012, 51.25544499999997],
      [4.388709317791012, 51.256038],
      [4.388721317791013, 51.256572],
      [4.388753317791012, 51.257796000000006],
      [4.388773317791013, 51.258551999999995],
      [4.388776317791013, 51.258757999999965],
      [4.3887783177910125, 51.25887999999996],
      [4.388783317791012, 51.25903699999998],
      [4.388845317791012, 51.25908400000001],
      [4.388888317791012, 51.259115999999985],
      [4.3889123177910125, 51.25913499999998],
      [4.388869317791013, 51.25921699999998],
      [4.388830317791013, 51.25930499999999],
      [4.388807317791012, 51.25937499999999],
      [4.388791317791012, 51.259446999999966],
      [4.388783317791012, 51.25950499999997],
      [4.388782317791013, 51.259575999999996],
      [4.388774317791012, 51.25964599999999],
      [4.388771317791012, 51.259903000000016],
      [4.388776317791013, 51.260152000000005],
      [4.388786317791014, 51.260549],
      [4.388794317791013, 51.26089300000001],
      [4.388800317791013, 51.26114999999999],
      [4.388815317791012, 51.261770999999996],
      [4.388817317791012, 51.26187600000001],
      [4.3888163177910124, 51.26189799999999],
      [4.388829317791012, 51.26194699999998],
      [4.388846317791013, 51.261995999999996],
      [4.388859317791012, 51.26203599999997],
      [4.388863317791013, 51.26207499999995],
      [4.388882317791012, 51.262461999999985],
      [4.388919317791013, 51.26366899999999],
      [4.388921317791014, 51.263693999999994],
      [4.388927317791014, 51.263713000000045],
      [4.388940317791013, 51.26372599999997],
      [4.388962317791012, 51.263746],
      [4.3889823177910126, 51.26376099999998],
      [4.389021317791013, 51.263780000000004],
      [4.389045317791012, 51.263787999999984],
      [4.389076317791012, 51.263794000000004],
      [4.389101317791012, 51.26380300000002],
      [4.389120317791012, 51.26381599999999],
      [4.389132317791011, 51.26382799999996],
      [4.389141317791013, 51.26384599999999],
      [4.389168317791013, 51.26385499999999],
      [4.389205317791013, 51.26385899999996],
      [4.389291317791012, 51.26385699999997],
      [4.389601317791013, 51.26384099999999],
      [4.389890317791012, 51.26382799999996],
      [4.389972317791013, 51.26382600000001],
      [4.390046317791012, 51.263822999999995],
      [4.390134317791012, 51.263820999999986],
      [4.391204317791012, 51.26380999999997],
      [4.391792317791013, 51.26380300000002],
      [4.392422317791013, 51.26379299999998],
      [4.392903317791013, 51.26378700000001],
      [4.393062317791013, 51.263783999999966],
      [4.393184317791013, 51.26378299999999],
      [4.393301317791012, 51.26377899999997],
      [4.3934233177910125, 51.26377299999997],
      [4.393608317791013, 51.26376200000001],
      [4.393764317791013, 51.26374999999999],
      [4.393923317791013, 51.26373799999999],
      [4.394063317791012, 51.26372400000001],
      [4.394193317791013, 51.26371099999999],
      [4.394359317791013, 51.26369200000001],
      [4.394521317791011, 51.26366899999999],
      [4.394651317791014, 51.26364799999996],
      [4.394793317791013, 51.26362999999999],
      [4.394941317791012, 51.26361099999997],
      [4.395058317791013, 51.26359699999999],
      [4.395202317791012, 51.26358300000001],
      [4.395492317791013, 51.26355600000001],
      [4.395782317791012, 51.26352599999996],
      [4.3959653177910125, 51.263507999999995],
      [4.396153317791013, 51.263491999999985],
      [4.396290317791013, 51.26347799999998],
      [4.396431317791012, 51.26346399999998],
      [4.396673317791013, 51.263436999999996],
      [4.396882317791014, 51.263415999999985],
      [4.397042317791013, 51.263401],
      [4.397244317791012, 51.26338200000001],
      [4.397473317791013, 51.26336],
      [4.3976993177910115, 51.26333799999998],
      [4.397866317791013, 51.263318000000005],
      [4.3979473177910124, 51.263309],
      [4.398070317791013, 51.26329],
      [4.398224317791012, 51.26326199999996],
      [4.398256317791012, 51.26325300000003],
      [4.398316317791012, 51.26333299999999],
      [4.398364317791013, 51.263323],
      [4.398439317791013, 51.26330099999996],
      [4.3985643177910125, 51.263258],
      [4.398654317791013, 51.263231],
      [4.398764317791013, 51.26319099999999],
      [4.398906317791012, 51.26313099999998],
      [4.399042317791012, 51.26306799999996],
      [4.399190317791013, 51.26299600000001],
      [4.399346317791012, 51.26291599999997],
      [4.399725317791011, 51.26268899999999],
      [4.399902317791013, 51.26258799999997],
      [4.400084317791013, 51.262485999999974],
      [4.400361317791012, 51.26235],
      [4.400517317791013, 51.262282000000006],
      [4.400992317791012, 51.26207999999997],
      [4.4019383177910125, 51.26165899999996],
      [4.4022483177910114, 51.261542000000006],
      [4.402728317791013, 51.26137999999998],
      [4.403313317791013, 51.26123199999998],
      [4.403477317791012, 51.261191],
      [4.403977317791013, 51.261080000000014],
      [4.404424317791013, 51.26099899999997],
      [4.404457317791012, 51.260993999999975],
      [4.404678317791013, 51.26096100000002],
      [4.4048673177910125, 51.26094000000002],
      [4.405032317791012, 51.26093199999996],
      [4.405177317791012, 51.260929000000004],
      [4.405327317791013, 51.260933000000016],
      [4.405391317791013, 51.26093599999998],
      [4.405484317791013, 51.260940999999995],
      [4.4058143177910125, 51.26096699999997],
      [4.406221317791013, 51.260997999999994],
      [4.4068753177910125, 51.26104200000002],
      [4.407902317791012, 51.26111399999997],
      [4.4081713177910125, 51.26112599999999],
      [4.4084193177910125, 51.26113399999997],
      [4.408726317791014, 51.261136999999955],
      [4.412883317791013, 51.26109799999998],
      [4.4144883177910135, 51.261080000000014],
      [4.414909317791012, 51.261065],
      [4.415285317791013, 51.26096399999999],
      [4.4154913177910124, 51.26091499999997],
      [4.415679317791012, 51.26083999999998],
      [4.415843317791013, 51.26075399999997],
      [4.415975317791013, 51.260650999999996],
      [4.416042317791014, 51.26058500000001],
      [4.4161773177910115, 51.26040899999998],
      [4.4162153177910115, 51.26031899999998],
      [4.416261317791013, 51.260237999999966],
      [4.4162983177910125, 51.260147999999965],
      [4.416317317791012, 51.26009400000001],
      [4.416316317791012, 51.26007500000001],
      [4.416314317791013, 51.26002499999999],
      [4.416312317791012, 51.25998600000001],
      [4.4162913177910115, 51.25951199999997],
      [4.416268317791013, 51.258729999999986],
      [4.4162533177910115, 51.25820399999999],
      [4.416254317791013, 51.25803599999996],
      [4.4162533177910115, 51.258001999999976],
      [4.416240317791012, 51.257341999999994],
      [4.4162353177910125, 51.257216],
      [4.416230317791013, 51.25704199999998],
      [4.416230317791013, 51.257028999999974],
      [4.416224317791013, 51.25677499999999],
      [4.416231317791012, 51.256313999999975],
      [4.416226317791014, 51.25607799999998],
      [4.416225317791012, 51.256043999999974],
      [4.416219317791013, 51.25594699999997],
      [4.416210317791012, 51.255689],
      [4.4161973177910125, 51.255492000000004],
      [4.4161903177910125, 51.25538699999997],
      [4.416180317791013, 51.25516400000003],
      [4.416167317791014, 51.254864999999995],
      [4.416164317791012, 51.25466599999997],
      [4.416157317791012, 51.254126999999976],
      [4.416153317791013, 51.25398399999997],
      [4.416148317791013, 51.253813999999984],
      [4.416149317791012, 51.253762999999985],
      [4.416144317791011, 51.253727999999974],
      [4.416130317791013, 51.25362099999999],
      [4.416112317791011, 51.25354499999999],
      [4.416095317791012, 51.253496999999975],
      [4.416024317791012, 51.25335199999999],
      [4.415954317791012, 51.25323500000001],
      [4.4158923177910125, 51.253156000000004],
      [4.415793317791014, 51.25304800000001],
      [4.415611317791012, 51.25287500000001],
      [4.415328317791013, 51.252615],
      [4.415122317791013, 51.252356999999975],
      [4.4149773177910125, 51.25223100000001],
      [4.4148933177910115, 51.25214099999999],
      [4.414836317791012, 51.25203299999997],
      [4.414791317791011, 51.25192899999999],
      [4.414753317791011, 51.25182899999997],
      [4.414716317791013, 51.25169199999996],
      [4.414702317791012, 51.25160399999997],
      [4.414694317791014, 51.251557999999996],
      [4.414685317791013, 51.25148899999998],
      [4.414681317791013, 51.25143800000001],
      [4.414682317791012, 51.25140600000003],
      [4.414683317791011, 51.25135699999999],
      [4.414686317791013, 51.25127900000001],
      [4.414693317791012, 51.251200000000004],
      [4.414701317791013, 51.25113199999999],
      [4.414718317791013, 51.25104399999997],
      [4.414741317791012, 51.250960999999975],
      [4.414770317791013, 51.25087400000001],
      [4.414838317791013, 51.25071699999995],
      [4.415039317791012, 51.25047599999999],
      [4.415189317791013, 51.25026899999999],
      [4.415258317791013, 51.25017899999999],
      [4.415325317791012, 51.250090000000014],
      [4.415417317791013, 51.249973999999966],
      [4.415658317791014, 51.24968699999997],
      [4.415711317791012, 51.24962299999998],
      [4.415759317791013, 51.249555000000015],
      [4.415812317791013, 51.249469000000005],
      [4.415853317791013, 51.24939200000001],
      [4.415890317791011, 51.24932200000001],
      [4.415938317791012, 51.24921800000003],
      [4.415970317791013, 51.249139],
      [4.415999317791013, 51.249057999999984],
      [4.416022317791013, 51.248951999999974],
      [4.416041317791012, 51.24886699999994],
      [4.416051317791013, 51.24879599999996],
      [4.416053317791014, 51.248741],
      [4.416054317791013, 51.24870299999998],
      [4.416054317791013, 51.24862799999999],
      [4.416052317791012, 51.248563999999966],
      [4.416041317791012, 51.24848099999999],
      [4.4160313177910115, 51.248421999999984],
      [4.416027317791013, 51.24839699999996],
      [4.416011317791012, 51.248324000000004],
      [4.415991317791013, 51.248244999999976],
      [4.415969317791013, 51.248174999999975],
      [4.415949317791012, 51.248120000000014],
      [4.415945317791014, 51.248107999999995],
      [4.415910317791012, 51.248025],
      [4.4158663177910125, 51.247941999999945],
      [4.415833317791012, 51.247882999999966],
      [4.4157963177910124, 51.247824000000016],
      [4.415740317791013, 51.24774699999999],
      [4.415693317791012, 51.24768999999999],
      [4.415620317791014, 51.24759999999999],
      [4.415558317791013, 51.24753900000001],
      [4.415499317791013, 51.247477999999944],
      [4.4154143177910115, 51.24739899999999],
      [4.415340317791013, 51.24733399999999],
      [4.415278317791012, 51.247282000000006],
      [4.415194317791013, 51.247218999999966],
      [4.415095317791013, 51.24714999999997],
      [4.415011317791013, 51.247089999999965],
      [4.414704317791012, 51.24686999999998],
      [4.414444317791012, 51.24665599999997],
      [4.414260317791012, 51.24647699999998],
      [4.414117317791012, 51.246288],
      [4.413790317791013, 51.245805],
      [4.413749317791012, 51.24571299999999],
      [4.413737317791012, 51.245568999999975],
      [4.4137383177910126, 51.24551799999998],
      [4.413741317791013, 51.245483999999976],
      [4.413755317791012, 51.245435999999984],
      [4.413745317791012, 51.24528799999999],
      [4.413726317791013, 51.24512899999997],
      [4.413688317791013, 51.24503899999997],
      [4.413608317791013, 51.24505299999997],
      [4.413570317791013, 51.245047],
      [4.4134593177910135, 51.24501100000001],
      [4.413380317791012, 51.24497399999999],
      [4.413317317791011, 51.24496499999998],
      [4.413231317791012, 51.244907000000005],
      [4.413232317791013, 51.244864000000014],
      [4.4132233177910125, 51.24477999999999],
      [4.413216317791013, 51.244714999999985],
      [4.413174317791013, 51.244683999999964],
      [4.413238317791013, 51.244655999999985],
      [4.413085317791012, 51.24449299999997],
      [4.4129693177910125, 51.24430900000001],
      [4.412940317791013, 51.244209999999974],
      [4.412675317791012, 51.24284200000001],
      [4.412636317791014, 51.242711],
      [4.412536317791012, 51.242487000000004],
      [4.412395317791012, 51.24221399999997],
      [4.411900317791013, 51.24127599999998],
      [4.411668317791013, 51.24085300000001],
      [4.411596317791012, 51.240746000000016],
      [4.411494317791012, 51.240647999999986],
      [4.411388317791013, 51.24056499999999],
      [4.411274317791013, 51.24049900000001],
      [4.411060317791014, 51.240387999999975],
      [4.410790317791013, 51.240306000000004],
      [4.410477317791012, 51.24025899999997],
      [4.4102873177910125, 51.240248999999984],
      [4.410035317791012, 51.24025699999999],
      [4.409806317791013, 51.240287999999985],
      [4.409541317791013, 51.24036400000001],
      [4.4094043177910125, 51.24042400000002],
      [4.409177317791013, 51.24055899999996],
      [4.409096317791013, 51.240607000000004],
      [4.408929317791013, 51.240773],
      [4.4087943177910125, 51.24090399999998],
      [4.4086733177910125, 51.241023999999975],
      [4.4085523177910115, 51.24097799999999],
      [4.408307317791013, 51.240882999999975],
      [4.408196317791012, 51.24084500000003],
      [4.408150317791013, 51.24082299999996],
      [4.408134317791013, 51.24080899999996],
      [4.408119317791011, 51.24079600000001],
      [4.408083317791013, 51.24074499999994],
      [4.408053317791012, 51.24066199999999],
      [4.408085317791013, 51.240559999999995],
      [4.408166317791013, 51.24047900000001],
      [4.408332317791013, 51.24039499999998],
      [4.408542317791014, 51.240277999999996],
      [4.408713317791013, 51.240142999999996],
      [4.408803317791013, 51.240046999999976],
      [4.408839317791012, 51.23999700000001],
      [4.408907317791012, 51.239842],
      [4.408928317791013, 51.239744],
      [4.4089403177910125, 51.238958],
      [4.408932317791013, 51.23831200000001],
      [4.408945317791012, 51.23804799999996],
      [4.408948317791014, 51.23799399999997],
      [4.408961317791013, 51.237914999999994],
      [4.408992317791013, 51.23766499999997],
      [4.409033317791012, 51.237436999999936],
      [4.409039317791012, 51.237402],
      [4.409061317791012, 51.23698499999998],
      [4.409059317791012, 51.23664399999998],
      [4.409049317791013, 51.23626099999999],
      [4.409052317791013, 51.236101],
      [4.409059317791012, 51.235941],
      [4.409126317791012, 51.23562999999999],
      [4.409126317791012, 51.235536],
      [4.409127317791014, 51.235392999999995],
      [4.409117317791012, 51.23500499999994],
      [4.409124317791012, 51.23445600000001],
      [4.409139317791013, 51.233387],
      [4.409151317791013, 51.23289399999996],
      [4.409151317791013, 51.23277999999999],
      [4.409151317791013, 51.232721999999995],
      [4.409152317791013, 51.23229399999998],
      [4.409152317791013, 51.23164100000002],
      [4.409152317791013, 51.23143499999997],
      [4.409160317791013, 51.23112299999998],
      [4.409160317791013, 51.231039],
      [4.409160317791013, 51.230979999999974],
      [4.409160317791013, 51.23096900000001],
      [4.409160317791013, 51.230955999999985],
      [4.409160317791013, 51.23089800000001],
      [4.409161317791012, 51.23084899999999],
      [4.408949317791013, 51.23084799999999],
      [4.408690317791013, 51.23084799999999],
      [4.408549317791013, 51.23085699999997],
      [4.4084193177910125, 51.23087900000001],
      [4.407877317791012, 51.231024],
      [4.407701317791012, 51.231071999999955],
      [4.407609317791012, 51.23109599999998],
      [4.407518317791012, 51.23110999999998],
      [4.4074283177910125, 51.231114],
      [4.407302317791014, 51.231115],
      [4.4070213177910125, 51.231115],
      [4.406644317791013, 51.23111199999999],
      [4.406469317791013, 51.23109999999999],
      [4.405487317791012, 51.231098999999986],
      [4.405360317791013, 51.231098999999986],
      [4.405449317791012, 51.22980999999998],
      [4.4054583177910125, 51.229679],
      [4.405467317791013, 51.229544],
      [4.405487317791012, 51.22920099999994],
      [4.405497317791012, 51.22908199999995],
      [4.4055083177910115, 51.22894200000001],
      [4.4055083177910115, 51.22894200000001]
    ],
    type: 'LineString'
  }
}
